import { render, staticRenderFns } from "./PriceAreaGroup.vue?vue&type=template&id=1ffd17a0"
import script from "./PriceAreaGroup.vue?vue&type=script&lang=js"
export * from "./PriceAreaGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports